
  import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import Dialog from '@/components/dialog.vue';
	import UploadImg from '@/components/upload-img.vue';
  
	import axios from 'axios';
  import {
    productproductSpecNoImport
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog': Dialog,
      UploadImg,
    }
  })

  export default class ProductList extends Vue {
    @Prop() private show:boolean
    @Prop() private id:number
    // @Model('change') show!: boolean;
    private ExcelFilePath = []
    private ExcelFileName = ''
    private importId = 0
    private scheduleShow = false
    private importresult:any = {
      IsDealFinish:false,
      FailCount:0,
      progress:0,
    }
		private diaShow = false
		@Watch('show')
		private getshow(val){
			this.diaShow = val
		}

    private close(){
      this.ExcelFilePath = []
      this.ExcelFileName = ''
      this.scheduleShow = false
      this.$emit('change',false)
      this.$emit('close')
    }
    private uploadSuc(list,name){
      // console.log(list,name)
      this.ExcelFilePath = list
      this.ExcelFileName = name
    }
    private async confirmimport(){
      if(!this.ExcelFilePath||!this.ExcelFilePath.length){
        this.$message.error('请上传文件')
				return
      }
      try{
        let res:any = await productproductSpecNoImport({
					ExcelFilePath:this.ExcelFilePath[0],
          ExcelFileName:this.ExcelFileName,
          ProductId:this.id
				})
				if(res.IsSuccess){
					this.importId = res.Result.RecordId
					this.gethandleresult(res.Result.RecordId,false)
					this.scheduleShow = true
				}
      }finally{
        //
      }
    }
    private async gethandleresult(RecordId,IsExport){
      let res:any = await axios.get('/pc/product/productSpecNoImportResultExport'+`?RecordId=${RecordId}&IsExport=${IsExport}`,{
					responseType:IsExport?'blob':undefined,
				})
				if(!IsExport){
					if(res.data.IsSuccess){
						this.importresult = {
							...res.data.Result,
							progress:50,
						}
						if(!res.data.Result.IsDealFinish){
							this.importresult.progress = 50
							setTimeout(()=>{
								this.gethandleresult(RecordId,false)
							},500)
						}else{
							this.importresult = {
								...res.data.Result,
								progress:100,
							}
						}
					}else{
						this.$message.error(res.data.Message)
					}
				}else{
					let blob = new Blob([res.data],{type:"application/octet-stream; charset=utf-8"})
					let a = document.createElement('a')
					a.style.display = 'none'
					a.download = `导入规格编码反馈表格.xlsx`
					a.href = URL.createObjectURL(blob)
					a.click()
					a.remove()
				}
    }
  }
